export const embedYouTubeUrl = 'https://www.youtube.com/embed/';
